import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

/**
 * Standardized form hook for all app forms.
 * Enforces Zod schema usage with react-hook-form.
 */
const useZodForm = ({ schema, defaultValues = {}, mode = "onSubmit", reValidateMode = "onChange" }) => {
  return useForm({
    defaultValues,
    resolver: zodResolver(schema),
    mode,
    reValidateMode,
  });
};

export default useZodForm;
